/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duct_Type_ExhaustInputs */



/**
* | output |
* | --- |
* | "Exhaust air" |
*
* @param {Duct_Type_ExhaustInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const duct_type_exhaust = /** @type {((inputs?: Duct_Type_ExhaustInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duct_Type_ExhaustInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Exhaust air")
	return /** @type {LocalizedString} */ ("Air rejeté")
});